import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { translate } from 'react-translate';
import { compose } from 'redux';
import { Card, Container, Grid, Image, Segment, Button } from 'semantic-ui-react';
import { setEnv } from '../../actions/AppActions';
import bientot from '../../assets/img/bientot.png';
import comblesAmenages from '../../assets/img/comblesamenages.PNG';
import comblesperdues from '../../assets/img/comblesperdues.PNG';
import isolationMursExterieurs from '../../assets/img/isomurexterieur.PNG';
import isolationMursInterieurs from '../../assets/img/isomurinterieur.PNG';
import KnaufLogoCloud from '../../assets/img/KnaufLogoCloud.png';
import plafond from '../../assets/img/plafond.PNG';
import envList from '../../constants/envList';
import './Homepage.css';
import { isSignedIn, onSignOut } from '../../Auth';
import LoginComponent from './LoginComponent';
import userService from '../../services/userService';

/**
 * @path /
 * the main page, is used to know what calculator to used
 */
class Homepage extends Component {
  static propTypes = {
    setEnv: PropTypes.func,
    t: PropTypes.func,
    app: PropTypes.shape({
      env: PropTypes.string,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      displayLogin: false,
    };
    this.onLinkClick = this.onLinkClick.bind(this);
    sessionStorage.clear();
    localStorage.clear();
  }

  /**
   * set in the store the environnements
   * @param {string} env the environement where are the next pages
   */
  onLinkClick(env) {
    const { setEnv } = this.props;
    setEnv(env);
    userService.setEnv(env);
  }

  handleLogin = () => {
    const { displayLogin } = this.state;
    this.setState({ displayLogin: !displayLogin });
  }

  signOut() {
    onSignOut().then(window.location = '/');
  }

  render() {
    const { t } = this.props;
    const { displayLogin } = this.state;

    return (
      <Segment basic id="homepageMain">
        { displayLogin && (
          <LoginComponent
            open={displayLogin}
            onClose={() => this.handleLogin()}
          />
        )}
        <Container>
          <Image src={KnaufLogoCloud} size="large" id="KnaufLogoCloud" />
          <Segment basic id="windowHomepage">
            <Grid columns="equal" id="homepageCardContainer">
              <Grid.Row>
                <Grid.Column mobile={8} tablet={5} computer={3}>
                  <Container>
                    <Link
                      to={`/${envList.CA.path}/${envList.CA.first}`}
                      className="linkPath"
                      onClick={() => { this.onLinkClick(envList.CA.path); }}
                    >
                      <Card className="infoPrestationsCard">
                        <Image
                          src={comblesAmenages}
                          size="medium"
                          centered
                          className="infoEnterpriseImg"
                        />
                        <div className="infoEnterpriseText">
                          {t('combles_amenage_title')}
                          {/* Combles aménagés */}
                        </div>
                      </Card>
                    </Link>
                  </Container>
                </Grid.Column>
                <Grid.Column mobile={8} tablet={5} computer={3}>
                  <Container>
                    <Link
                      to={`/${envList.CP.path}/${envList.CP.first}`}
                      className="linkPath"
                      onClick={() => { this.onLinkClick(envList.CP.path); }}
                    >
                      <Card className="infoPrestationsCard">
                        <Image
                          src={comblesperdues}
                          size="medium"
                          centered
                          className="infoEnterpriseImg"
                        />
                        <div className="infoEnterpriseText">
                          {t('combles_perdues_title')}
                          {/* Combles perdues */}
                        </div>
                      </Card>
                    </Link>
                  </Container>
                </Grid.Column>
                <Grid.Column mobile={8} tablet={5} computer={3}>
                  <Container>
                    {/* <Link to='/typeuser' className='linkPath'> */}
                    <Card className="infoPrestationsCard">
                      <Image src={bientot} className="comingSoon" />
                      <Image src={plafond} size="medium" centered className="infoEnterpriseImg" />
                      <div className="infoEnterpriseText">
                        {t('plafond_title')}
                        {/* Plafond */}
                      </div>
                    </Card>
                    {/* </Link> */}
                  </Container>
                </Grid.Column>
                <Grid.Column mobile={8} tablet={5} computer={3}>
                  <Container>
                    <Link
                      to={`/${envList.IME.path}/${envList.IME.first}`}
                      className="linkPath"
                      onClick={() => { this.onLinkClick(envList.IME.path); }}
                    >
                      <Card className="infoPrestationsCard">
                        <Image
                          src={isolationMursInterieurs}
                          size="medium"
                          centered
                          className="infoEnterpriseImg"
                        />
                        <div className="infoEnterpriseText">
                          {t('isolation_murs_int')}
                          {/* Isolation murs intérieurs */}
                        </div>
                      </Card>
                    </Link>
                  </Container>
                </Grid.Column>
                <Grid.Column mobile={8} tablet={5} computer={3}>
                  <Container>
                    {/* <Link to='/typeuser' className='linkPath'> */}
                    <Card className="infoPrestationsCard">
                      <Image src={bientot} className="comingSoon" />
                      <Image
                        src={isolationMursExterieurs}
                        size="medium"
                        centered
                        className="infoEnterpriseImg"
                      />
                      <div className="infoEnterpriseText">
                        {t('isolation_murs_ext')}
                        {/* Isolations murs extérieurs */}
                      </div>
                    </Card>
                    {/* </Link> */}
                  </Container>
                </Grid.Column>
              </Grid.Row>
              {isSignedIn()
                ? (
                  <Link to="/">
                    <Button secondary basic onClick={this.signOut} id="seDecoBtn">
                      {t('logout')}
                    </Button>
                  </Link>
                ) : (
                  <Button secondary basic onClick={() => this.handleLogin()} id="seDecoBtn">
                    {t('login')}
                  </Button>
                )
              }
            </Grid>
          </Segment>
        </Container>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
});

const mapActionToProps = {
  setEnv,
};

export default compose(
  connect(mapStateToProps, mapActionToProps),
  translate('Homepage')
)(Homepage);



// WEBPACK FOOTER //
// ./src/components/Login/Homepage.jsx